var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help",class:_vm.color},[_c('div',{staticClass:"help-content"},[_c(_vm.howTos[_vm.level],{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }